import { render, staticRenderFns } from "./BranchConfiguration.vue?vue&type=template&id=18561f16&"
import script from "./BranchConfiguration.vue?vue&type=script&lang=js&"
export * from "./BranchConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports